// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shared v13 dense-form + layout rules for the #watchlist-menu root.
 *
 * This stylesheet is imported by the OSS WatchlistPlugin module, which the Pro
 * subclass also pulls in, so one copy covers BOTH builds. The OSS and Pro
 * watchlist menus share the #watchlist-menu root id, so any rule that both need
 * (focus indication, stacked-field headroom, the add-satellite row) lives here;
 * Pro-only chrome (results table, row actions, dropzone) lives in the Pro CSS.
 */

/* Stacked labelled rows in a card need headroom or the floating "active" label
 * collides with / strikes through the row above (the shared kt-field-row
 * default of 6px is too tight once a card stacks more than one labelled row). */
#watchlist-menu .kt-field-row .input-field.col { margin-top: 20px; }
#watchlist-menu .kt-section-label + .kt-field-row .input-field.col { margin-top: 8px; }

/* Focus indication: the app-wide :focus-visible outline (offset 2px) overlaps
 * the floating label above each field. Swap it for KeepTrack's underline. */
#watchlist-menu .input-field input:focus,
#watchlist-menu .input-field textarea:focus {
  border-bottom-color: var(--color-primary) !important;
  box-shadow: 0 1px 0 0 var(--color-primary);
}

#watchlist-menu .input-field input:focus-visible,
#watchlist-menu .input-field textarea:focus-visible {
  outline: none;
}

/* Add-satellite row: the NORAD input grows, the add control hugs the right. */
.watchlist-add-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}

.watchlist-add-row .input-field {
  flex: 1 1 auto;
  margin: 12px 0 0;
}

.watchlist-add-row .icon-btn {
  flex: 0 0 auto;
}

.watchlist-add-row .watchlist-add {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/watchlist/watchlist.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;;gFAEgF;AAChF,iDAAiD,gBAAgB,EAAE;AACnE,qEAAqE,eAAe,EAAE;;AAEtF;4EAC4E;AAC5E;;EAEE,oDAAoD;EACpD,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd","sourcesContent":["/*\n * Shared v13 dense-form + layout rules for the #watchlist-menu root.\n *\n * This stylesheet is imported by the OSS WatchlistPlugin module, which the Pro\n * subclass also pulls in, so one copy covers BOTH builds. The OSS and Pro\n * watchlist menus share the #watchlist-menu root id, so any rule that both need\n * (focus indication, stacked-field headroom, the add-satellite row) lives here;\n * Pro-only chrome (results table, row actions, dropzone) lives in the Pro CSS.\n */\n\n/* Stacked labelled rows in a card need headroom or the floating \"active\" label\n * collides with / strikes through the row above (the shared kt-field-row\n * default of 6px is too tight once a card stacks more than one labelled row). */\n#watchlist-menu .kt-field-row .input-field.col { margin-top: 20px; }\n#watchlist-menu .kt-section-label + .kt-field-row .input-field.col { margin-top: 8px; }\n\n/* Focus indication: the app-wide :focus-visible outline (offset 2px) overlaps\n * the floating label above each field. Swap it for KeepTrack's underline. */\n#watchlist-menu .input-field input:focus,\n#watchlist-menu .input-field textarea:focus {\n  border-bottom-color: var(--color-primary) !important;\n  box-shadow: 0 1px 0 0 var(--color-primary);\n}\n\n#watchlist-menu .input-field input:focus-visible,\n#watchlist-menu .input-field textarea:focus-visible {\n  outline: none;\n}\n\n/* Add-satellite row: the NORAD input grows, the add control hugs the right. */\n.watchlist-add-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.watchlist-add-row .input-field {\n  flex: 1 1 auto;\n  margin: 12px 0 0;\n}\n\n.watchlist-add-row .icon-btn {\n  flex: 0 0 auto;\n}\n\n.watchlist-add-row .watchlist-add {\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
